import { render, staticRenderFns } from "./MonitoringKebakaran.vue?vue&type=template&id=76070b9f"
import script from "./MonitoringKebakaran.vue?vue&type=script&lang=js"
export * from "./MonitoringKebakaran.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports